import initializeLodash from './plugins/lodash';
import initializeErrorScreen from './plugins/error-screen';

import component from './PlaypositErrorScreen.vue';

const install = (Vue, opts) => {
  if (install.installed) return;
  install.installed = true;
  initializeLodash(Vue);
  initializeErrorScreen(Vue, opts, component);
};

const plugin = {
  install,
};

let GlobalVue = null;
if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.vue;
}

if (GlobalVue) {
  GlobalVue.use(plugin);
}

component.install = install;

// export default PlaypositErrorScreen;
export default component;